import React, { useState } from "react";
import { SelectForm } from "../../common/Buttons";
import TextInputModal from "../../common/TextInputModal";
import SelectInputAsync from "../../common/SelectInputAsync";

function UsersEditModal(props) {
  const action = props.action;
  const [state, setState] = useState({
    id: props.data?.id || "",
    email: props.data?.email || "",
    firstname: props.data?.firstname || "",
    lastname: props.data?.lastname || "",
    password: "",
    password_confirmation: "",
    // role: props.data?.role || props.auth.role,
    user_role_id: props.data?.user_role_id,
    store_id: props.data?.store_id,
    dpd_account: props.data?.dpd_account || "",
    dpd_password: props.data?.dpd_password || "",
  });

  const [errors, setErrors] = useState({});

  const onSubmit = (type, id) => {
    const {
      email,
      firstname,
      lastname,
      password,
      password_confirmation,
      user_role_id,
      store_id,
      dpd_account,
      dpd_password,
    } = state;
    const params = {
      user: {
        email,
        firstname,
        lastname,
        password,
        password_confirmation,
        user_role_id,
        store_id,
        dpd_account,
        dpd_password,
      },
    };
    // if(dpd_password.trim() !== "") {
    //   params.user.dpd_password = dpd_password
    // }
    if (type === "edit") {
      return props.updateUser(id, params).then((res) => {
        if (res.success) {
          if (props.auth.email == res.data.email) {
            return props.logoutUser();
          } else {
            return props.onClose();
          }
        } else {
          return setErrors(res.errors);
        }
      });
    } else if (props.action == "new") {
      return props.postUser(params).then((res) => {
        if (res.success) {
          return props.onClose();
        } else {
          return setErrors(res.errors);
        }
      });
    }
  };

  const handleChange = (e, select) => {
    if (select) {
      setState({
        ...state,
        [select]: e,
      });
    } else {
      setState({
        ...state,
        [e.target.name]: e.target.value,
      });
    }
  };

  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <div>
        <TextInputModal
          required={true}
          type="email"
          text="E.mail"
          name="email"
          value={state.email}
          error={errors.email && errors.email.map((item) => `${item} `)}
          onChange={(e) => handleChange(e)}
        />
        <TextInputModal
          type="text"
          text="Firstname"
          name="firstname"
          value={state.firstname}
          error={errors.firstname && errors.firstname.map((item) => `${item} `)}
          onChange={(e) => handleChange(e)}
        />
        <TextInputModal
          type="text"
          text="Lastname"
          name="lastname"
          value={state.lastname}
          error={errors.lastname && errors.lastname.map((item) => `${item} `)}
          onChange={(e) => handleChange(e)}
        />
        {props.auth.role == "admin" && (
          <SelectInputAsync
            label="Role"
            required={true}
            api_url={"/api/v1/user_roles"}
            rebuildArray={(arr) =>
              arr.map((role) => ({ label: role.title, value: role.id }))
            }
            value={state.user_role_id}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "user_role_id",
                  value: e,
                },
              })
            }
          />
        )}
        <SelectInputAsync
            label="Store"
            required={false}
            api_url={"/api/v1/stores"}
            rebuildArray={(arr) =>
              arr.data.map((store) => ({ label: store.name, value: store.id }))
            }
            value={state.store_id}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "store_id",
                  value: e,
                },
              })
            }
          />
        <TextInputModal
          required={true}
          type="password"
          text="Password"
          name="password"
          value={state.password}
          error={errors.password && errors.password.map((item) => `${item} `)}
          onChange={(e) => handleChange(e)}
        />
        <TextInputModal
          required={true}
          type="password"
          text="Confirm password"
          name="password_confirmation"
          value={state.password_confirmation}
          error={
            errors.password_confirmation &&
            errors.password_confirmation.map((item) => `${item} `)
          }
          onChange={(e) => handleChange(e)}
        />
        <hr />
        <TextInputModal
          text="DPD account"
          name="dpd_account"
          value={state.dpd_account}
          error={
            errors.dpd_account && errors.dpd_account.map((item) => `${item} `)
          }
          onChange={(e) => handleChange(e)}
        />
        <TextInputModal
          text="DPD Password"
          name="dpd_password"
          value={state.dpd_password}
          error={
            errors.dpd_password && errors.dpd_password.map((item) => `${item} `)
          }
          onChange={(e) => handleChange(e)}
        />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary btn-block"
          aria-label="Close"
          onClick={() => onSubmit(action, state.id)}
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default UsersEditModal;
